// extracted by mini-css-extract-plugin
export var closeButton = "_q-0";